import { BitfApiRequestPart } from './bitf-api-request-part';

import { EApiRequestPartKeys, EBitfApiRequestPartsNames } from '@enums';

export class BitfPaginationApiRequestPart extends BitfApiRequestPart {
  constructor({
    key = EApiRequestPartKeys.PAGINATION,
    initialPagination,
    options,
  }: {
    key?: EApiRequestPartKeys;
    initialPagination: { page?: number; size?: number; paginationInfo?: string };
    options?: { pageSizeOptions?: number[]; pageIndexOffset?: number };
  }) {
    super(key, EBitfApiRequestPartsNames.PAGINATION, { data: initialPagination }, options);
  }

  build() {
    const page = this.data.page;
    const size = this.data.size;
    this.part = {
      ...(page !== undefined && { page }),
      ...(size !== undefined && { size }),
    };

    if (this.data.paginationInfo || this.data.paginationInfo === '') {
      this.part.paginationInfo = this.data.paginationInfo;
    }
  }
}
